import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import {
  type DialogFooterDataProps,
  dialogFooterDataSchema,
} from "./Dialog.schema";
import { DialogFooter } from "./DialogFooter";
import { DIALOG_FOOTER_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [DIALOG_FOOTER_TAG_NAME]: {
      props: DialogFooterDataProps;
      handle: undefined;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-dialog-footer": HTMLElement;
  }
}

function RWCDialogFooterComponent(): JSX.Element {
  return (
    <DialogFooter>
      <slot />
    </DialogFooter>
  );
}

componentManager.register(
  rwc(DIALOG_FOOTER_TAG_NAME, {
    component: RWCDialogFooterComponent,
    dataSchema: dialogFooterDataSchema,
    usesSlots: true,
  }),
);
